import { render, staticRenderFns } from "./delivery-add-or-update.vue?vue&type=template&id=0f0a159c&scoped=true&"
import script from "./delivery-add-or-update.vue?vue&type=script&lang=js&"
export * from "./delivery-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./delivery-add-or-update.vue?vue&type=style&index=0&id=0f0a159c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0a159c",
  null
  
)

export default component.exports